// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-border-sm {
  height: 0.88rem;
  width: 0.88rem;
}

.action-icon--disabled {
  opacity: 0.35;
  color: #9ca3af;
  cursor: default;
  pointer-events: none;
}

.action-icon--enabled {
  color: #2196f3;
}

.row-reorder__header {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}

.row-reorder__header-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #9aa3ad;
  line-height: 1;
  font-size: 30px;
}

.row-reorder__header-icon svg {
  fill: currentColor;
}

.row-reorder__cell {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  text-align: center;
}

.row-reorder__handle {
  border: 0;
  background: transparent;
  color: #9aa3ad;
  cursor: grab;
  padding: 0;
  line-height: 1;
}

.row-reorder__handle:active {
  cursor: grabbing;
}

.row-reorder__icon {
  font-size: 14px;
}

::ng-deep .cdk-drag-preview {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #d9dee5;
}

/* Keep dragged row preview identical to table row layout (no compressed cells). */
::ng-deep .datatable-table tr.cdk-drag-preview {
  display: table;
  table-layout: fixed;
  width: 100% !important;
  background: #ffffff;
}

::ng-deep .datatable-table tr.cdk-drag-preview > td {
  box-sizing: border-box;
}

::ng-deep .cdk-drag-placeholder {
  opacity: 0;
}

::ng-deep .cdk-drop-list-dragging tr:not(.cdk-drag-placeholder) {
  transition: transform 180ms ease;
}

::ng-deep ngb-pagination ul {
  margin-bottom: 0 !important;
}

/* Table */
.datatable-table {
  --bs-table-color: var(--bs-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: #e0e5ec;
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-body-color);
  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);
  --bs-table-active-color: var(--bs-body-color);
  --bs-table-active-bg: rgba(0, 0, 0, 0.1);
  --bs-table-hover-color: var(--bs-body-color);
  --bs-table-hover-bg: rgba(224, 229, 236, 0.25);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}

.datatable-table > :not(caption) > * > * {
  padding: 0.75rem 0.75rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.datatable-table > tbody {
  vertical-align: inherit;
}

.datatable-table > thead {
  vertical-align: bottom;
}

.datatable-table > :not(caption) > * {
  border-width: 1px 0;
}

.datatable-table > :not(caption) > * > * {
  border-width: 0 1px;
}

.datatable-table > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color);
}

.datatable-table > tbody > tr.no-row-hover:hover > * {
  --bs-table-accent-bg: transparent;
  color: inherit;
}

.invoice .datatable-table tbody tr td {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.datatable-table {
  border-collapse: collapse;
}

.datatable-table > tbody > tr > td,
.datatable-table > tbody > tr > th,
.datatable-table > tfoot > tr > td,
.datatable-table > tfoot > tr > th,
.datatable-table > thead > tr > td,
.datatable-table > thead > tr > th {
  vertical-align: middle;
  padding: 0.561rem;
}

.datatable-table > thead > tr > th {
  vertical-align: bottom;
  text-align: left;
  border-bottom: none;
}

.datatable-table > tfoot > tr > th {
  vertical-align: bottom;
  text-align: left;
}

.datatable-table th {
  vertical-align: bottom;
  text-align: left;
}

.table-cell-truncate {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.table-cell-truncate--with-badge {
  overflow: visible;
  max-width: none;
}

.table-cell__with-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.table-cell__text {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ocr-proc-operation__header,
.ocr-proc-operation__cell {
  text-align: center !important;
}

.ocr-proc-operation__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

/* Numeric amount cells use accounting-style alignment. */
.datatable-table td.amount {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.datatable-table td.amount.amount-negative {
  color: #dc2626;
}

.datatable-table td.erp-rule-cell {
  text-align: center !important;
}

.datatable-table td.erp-rule-cell .erp-rule-cell__content {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto;
  margin: 0 auto;
}

:host ::ng-deep .datatable-table td.erp-rule-cell .e-checkbox-wrapper,
:host ::ng-deep .datatable-table td.erp-rule-cell .e-checkbox {
  float: none !important;
  margin: 0 auto !important;
  display: inline-flex !important;
}

.table-note {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #4a4f57;
  font-size: 0.95rem;
  margin-bottom: 10px;
}

.table-note__count {
  color: #d92b2b;
  font-weight: 600;
}

.table-new-badge {
  margin-left: 8px;
  background-color: #fde2e2;
  color: #a94442;
  font-weight: 600;
  font-size: 1em;
  padding: 0.25em 0.6em;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.6);
  }
  70% {
    transform: scale(1.05);
    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0);
  }
  100% {
    transform: scale(1);
  }
}
.pulse-badge {
  animation: pulse 1.8s infinite;
}

.table-mapping-badge {
  margin-left: 8px;
  background-color: #fde2e2;
  color: #a94442;
  font-weight: 600;
  font-size: 0.95em;
  padding: 0.25em 0.6em;
}

.datatable-table th a {
  text-decoration: none;
  color: inherit;
}

.table-link-icon {
  color: #c2c6cc;
  font-weight: 600;
  display: inline-block;
}

.table-link-icon--active {
  color: #2196F3;
  font-weight: 600;
}

.table-link-icon--prefilled {
  color: #2196F3;
  font-weight: 600;
}

.table-link-header {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

/* Mapping status pill (used in column-mapping modal table) */
.mapping-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.2;
}

.mapping-status-badge--mapped {
  background-color: #dcfce7;
  color: #15803d;
}

.mapping-status-badge--na {
  background-color: #e5e7eb;
  color: #6b7280;
}

/* Upload-session status pill styles */
.session-status-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  line-height: 1.2;
}

.session-status-badge--open {
  background-color: #e5e7eb;
  color: #6b7280;
}

.session-status-badge--processing {
  background-color: #dbeafe;
  color: #1d4ed8;
}

.session-status-badge--processed {
  background-color: #e0f2fe;
  color: #0369a1;
}

.session-status-badge--reconciled {
  background-color: #dcfce7;
  color: #15803d;
}

.session-status-badge--default {
  background-color: #f3f4f6;
  color: #4b5563;
}

::ng-deep .e-dropdown-popup .mapping-option-disabled,
::ng-deep .e-dropdown-popup .e-list-item .mapping-option-disabled,
::ng-deep .e-dropdownbase .mapping-option-disabled,
::ng-deep .e-dropdownbase .e-list-item .mapping-option-disabled {
  color: #9aa3ad !important;
}

/*Table Sorter icon - Part of Table*/
.datatable-sorter {
  display: inline-block;
  height: 100%;
  position: relative;
  width: 100%;
  padding-right: 1rem;
}

.datatable-sorter::before,
.datatable-sorter::after {
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  right: 4px;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  opacity: 0.2;
}

.datatable-sorter::before {
  bottom: 4px;
}

.datatable-sorter::after {
  top: 0px;
}

.asc .datatable-sorter::after,
.desc .datatable-sorter::before {
  opacity: 0.6;
}

.datatables-empty {
  text-align: center;
}

.datatable-top::after,
.datatable-bottom::after {
  clear: both;
  content: " ";
  display: table;
}

.btn-datatable {
  height: 20px !important;
  width: 20px !important;
  font-size: 0.75rem;
  border-radius: 0.35rem !important;
}

.sbp-dropdown-example .dropdown-menu {
  display: inline-block;
  position: relative;
  float: none;
  max-width: 15rem;
}

.sbp-preview {
  border-radius: 0.35rem;
  border: 0.25rem solid #e0e5ec;
  border-style: solid;
}

.sbp-preview .sbp-preview-content {
  padding: 1.5rem;
  border-bottom: 1px solid #e0e5ec;
  position: relative;
}

.sbp-preview .sbp-preview-code {
  background-color: #f2f6fc;
  padding: 1.5rem;
  border-bottom: 1px solid #e0e5ec;
}

.sbp-preview .sbp-preview-code .nav-tabs {
  border-bottom-color: transparent;
  font-size: 0.75rem;
  font-weight: 500;
}

.sbp-preview .sbp-preview-code .nav-tabs .nav-item .nav-link {
  border-bottom: 0;
  display: inline-flex;
  align-items: center;
}

.sbp-preview .sbp-preview-code .nav-tabs .nav-item .nav-link.active {
  border-color: transparent;
  background-color: #2f2f2f;
  color: white;
}

.sbp-preview .sbp-preview-code .nav-tabs .nav-item .nav-link .img-pug {
  height: 1em;
  padding: 1px 0;
}

.sbp-preview .sbp-preview-text {
  background-color: #f2f6fc;
  font-size: 0.875rem;
  padding: 1.5rem;
}

code[class*=language-],
pre[class*=language-] {
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  color: #eee;
  background: #2f2f2f;
  font-family: "SFMono-Regular", "Consolas", "Liberation Mono", "Menlo", monospace;
  font-size: 0.875rem;
  line-height: 1.5em;
  -moz-tab-size: 4;
  tab-size: 4;
  hyphens: none;
}

code[class*=language-]::selection,
pre[class*=language-]::selection,
code[class*=language-] ::selection,
pre[class*=language-] ::selection {
  background: #363636;
}

:not(pre) > code[class*=language-] {
  white-space: normal;
  border-radius: 0.2em;
  padding: 0.1em;
}

pre[class*=language-] {
  overflow: auto;
  position: relative;
  margin: 0;
  padding: 1rem;
  max-height: 35rem;
}

.language-css > code,
.language-sass > code,
.language-scss > code {
  color: #fd9170;
}

[class*=language-] .namespace {
  opacity: 0.7;
}

.token.atrule {
  color: #c792ea;
}

.token.attr-name {
  color: #ffcb6b;
}

.token.attr-value {
  color: #a5e844;
}

.token.attribute {
  color: #a5e844;
}

.token.boolean {
  color: #c792ea;
}

.token.builtin {
  color: #ffcb6b;
}

.token.cdata {
  color: #80cbc4;
}

.token.char {
  color: #80cbc4;
}

.token.class {
  color: #ffcb6b;
}

.token.class-name {
  color: #f2ff00;
}

.token.comment {
  color: #616161;
}

.token.constant {
  color: #c792ea;
}

.token.deleted {
  color: #ff6666;
}

.token.doctype {
  color: #616161;
}

.token.entity {
  color: #ff6666;
}

.token.function {
  color: #c792ea;
}

.token.hexcode {
  color: #f2ff00;
}

.token.id {
  color: #c792ea;
  font-weight: bold;
}

.token.important {
  color: #c792ea;
  font-weight: bold;
}

.token.inserted {
  color: #80cbc4;
}

.token.keyword {
  color: #c792ea;
}

.token.number {
  color: #fd9170;
}

.token.operator {
  color: #89ddff;
}

.token.prolog {
  color: #616161;
}

.token.property {
  color: #80cbc4;
}

.token.pseudo-class {
  color: #a5e844;
}

.token.pseudo-element {
  color: #a5e844;
}

.token.punctuation {
  color: #89ddff;
}

.token.regex {
  color: #f2ff00;
}

.token.selector {
  color: #ff6666;
}

.token.string {
  color: #a5e844;
}

.token.symbol {
  color: #c792ea;
}

.token.tag {
  color: #ff6666;
}

.token.unit {
  color: #fd9170;
}

.token.url {
  color: #ff6666;
}

.token.variable {
  color: #ff6666;
}

.trash-icon {
  cursor: pointer;
  transition: transform 0.2s;
}

/*Table Highlights - Hover clicked*/
/* Hover styling for table cells */
.hoverable:hover {
  background-color: rgba(0, 123, 255, 0.1); /* Light blue hover effect */
  transition: background-color 0.3s ease; /* Smooth animation */
}

/* Highlight clicked row */
.datatable-table tbody tr.clicked td {
  background-color: rgba(0, 123, 255, 0.2); /* Slightly darker blue for clicked row */
  transition: background-color 0.3s ease;
}

/* Optional: Highlight hovered rows */
.datatable-table tbody tr:hover td {
  background-color: rgba(0, 123, 255, 0.15); /* Hover effect for the entire row */
  transition: background-color 0.3s ease;
}

/* Add animation for smoother click transition */
@keyframes click-highlight {
  from {
    background-color: rgba(0, 123, 255, 0.3);
  }
  to {
    background-color: rgba(0, 123, 255, 0.2);
  }
}
.datatable-table tbody tr.clicked td {
  animation: click-highlight 0.4s ease;
}

/* Table Layout, Auto - Fit*/
/* 2. Inner container is auto-width, letting the table size by content */
.datatable-container {
  width: 100%; /*auto*/
  display: inline-block;
  position: relative;
}

/* 3. Table: let it expand based on content */
.datatable-table {
  border-collapse: collapse;
  table-layout: auto;
  width: 100%;
}

/* 4. Th and Td styles */
.datatable-table th,
.datatable-table td {
  border: 1px solid #ddd;
  padding: 8px;
  vertical-align: middle;
  white-space: nowrap;
}

/* 5. Hover and highlight styles */
.hoverable:hover {
  background-color: #f9f9f9;
}

.datatable-table tr.clicked td,
.datatable-table th.clicked {
  background-color: #f0f0f0;
}

/* Processing or repeat Icon */
.processing-icon {
  transition: transform 0.5s ease-in-out;
}

.processing-icon:hover {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.cwr-datatable .datable-container,
.cwr-datatable .datatable-table {
  width: 100% !important;
}

/*Start: Table Controls in datatables*/
/* table-controls.scss */
/* Layout */
.table-controls__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem;
  /* Responsive adjustments */
}
@media (max-width: 768px) {
  .table-controls__footer {
    flex-direction: column;
    text-align: center;
  }
  .table-controls__footer > * {
    margin-bottom: 0.5rem;
  }
}
.table-controls__pagination {
  /* Additional pagination styles if necessary */
}
.table-controls__info {
  flex: 1;
  text-align: center;
}
.table-controls__page-size {
  width: auto;
}

/*END: Table Controls in datatables*/
/*Start: Table Search with Title*/
.table-search {
  display: flex;
  align-items: center;
  width: 100%;
}
.table-search__input-wrapper {
  flex: 0 0 auto;
  margin-right: 2rem;
  max-width: 20rem;
}
.table-search__input {
  width: 100%;
}
.table-search__spinner-loading {
  width: 52px;
  position: absolute;
  top: 1px;
  right: 0;
  border: 0;
  margin-right: 1px;
}
.table-search__title-wrapper {
  flex: 1;
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
  font-weight: bold;
  color: #1da1f5;
  font-size: 1.1rem;
}
.table-search__session-id {
  color: #2563eb;
}

/*End: table Search with Title*/
.skeleton {
  height: 1rem;
  background: #e0e0e0;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
.style__file-list-view td {
  font-size: 11px;
}`, "",{"version":3,"sources":["webpack://./src/modules/custom-table/components/table-builder/table-builder.component.scss","webpack://./src/styles/core/variables/_global-theme.scss"],"names":[],"mappings":"AAEA;EACI,eCGa;EDFb,cCEa;ADHjB;;AAIA;EACI,aAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AADJ;;AAKA;EACI,cAAA;AAFJ;;AAKA;EACI,WAAA;EACA,eAAA;EACA,eAAA;AAFJ;;AAKA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAFJ;;AAKA;EACI,kBAAA;AAFJ;;AAKA;EACI,WAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;AAFJ;;AAKA;EACI,SAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;AAFJ;;AAKA;EACI,gBAAA;AAFJ;;AAKA;EACI,eAAA;AAFJ;;AAKA;EACI,sBAAA;EACA,mBAAA;EACA,yBAAA;AAFJ;;AAKA,kFAAA;AACA;EACI,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AAFJ;;AAKA;EACI,sBAAA;AAFJ;;AAKA;EACI,UAAA;AAFJ;;AAKA;EACI,gCAAA;AAFJ;;AAMA;EACI,2BAAA;AAHJ;;AAMA,UAAA;AACA;EACE,sCAAA;EACA,0BAAA;EACA,gCAAA;EACA,iCAAA;EACA,8CAAA;EACA,0CAAA;EACA,6CAAA;EACA,wCAAA;EACA,4CAAA;EACA,8CAAA;EACA,WAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;EACA,0CAAA;AAHF;;AAKA;EACE,wBAAA;EACA,oCAAA;EACA,wBAAA;EACA,wDAAA;AAFF;;AAIA;EACE,uBAAA;AADF;;AAGA;EACE,sBAAA;AAAF;;AAEA;EACE,mBAAA;AACF;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,8CAAA;EACA,kCAAA;AAGF;;AACA;EACE,iCAAA;EACA,cAAA;AAEF;;AAAA;EACE,mBAAA;EACA,sBAAA;AAGF;;AADA;EACE,yBAAA;AAIF;;AADA;;;;;;EAME,sBAAA;EACA,iBCvHuB;AD2HzB;;AADA;EACE,sBAAA;EACA,gBAAA;EACA,mBAAA;AAIF;;AADA;EACE,sBAAA;EACA,gBAAA;AAIF;;AADA;EACE,sBAAA;EACA,gBAAA;AAIF;;AADA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAIF;;AADA;EACE,iBAAA;EACA,eAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;AAIF;;AADA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAIF;;AADA;;EAEE,6BAAA;AAIF;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAIF;;AADA,yDAAA;AACA;EACE,iBAAA;EACA,kCAAA;AAIF;;AADA;EACE,cAAA;AAIF;;AADA;EACE,6BAAA;AAIF;;AADA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAIF;;AADA;;EAEE,sBAAA;EACA,yBAAA;EACA,+BAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAIF;;AADA;EACE,cAAA;EACA,gBAAA;AAIF;;AADA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAIF;;AADA;EACE;IACE,mBAAA;IACA,0CAAA;EAIF;EAFA;IACE,sBAAA;IACA,0CAAA;EAIF;EAFA;IACE,mBAAA;EAIF;AACF;AADA;EACE,8BAAA;AAGF;;AAAA;EACE,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAGF;;AAAA;EACE,qBAAA;EACA,cAAA;AAGF;;AAAA;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;AAGF;;AAAA;EACE,cAAA;EACA,gBAAA;AAGF;;AAAA;EACE,cAAA;EACA,gBAAA;AAGF;;AAAA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAGF;;AAAA,6DAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA,sCAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA;EACE,yBAAA;EACA,cAAA;AAGF;;AAAA;;;;EAIE,yBAAA;AAGF;;AAAA,oCAAA;AAEA;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;AAEF;;AACA;;EAEE,WAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,UAAA;EACA,kCAAA;EACA,mCAAA;EACA,YAAA;AAEF;;AACA;EACE,WAAA;AAEF;;AACA;EACE,QAAA;AAEF;;AACA;;EAEE,YAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;;EAEE,WAAA;EACA,YAAA;EACA,cAAA;AAEF;;AACA;EACE,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;AAEF;;AACA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AAEF;;AACA;EACE,sBAAA;EACA,6BAAA;EACA,mBAAA;AAEF;;AAAA;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;AAGF;;AADA;EACE,yBAAA;EACA,eAAA;EACA,gCAAA;AAIF;;AAFA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;AAKF;;AAHA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;AAMF;;AAJA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;AAOF;;AALA;EACE,WAAA;EACA,cAAA;AAQF;;AANA;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;AASF;;AANA;;EAEE,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,gFAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,WAAA;EAEA,aAAA;AASF;;AAKA;;;;EAIE,mBAAA;AASF;;AANA;EACE,mBAAA;EACA,oBAAA;EACA,cAAA;AASF;;AANA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,iBAAA;AASF;;AANA;;;EAGE,cAAA;AASF;;AANA;EACE,YAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;EACA,iBAAA;AASF;;AANA;EACE,cAAA;EACA,iBAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACE,cAAA;AASF;;AANA;EACI,eAAA;EACA,0BAAA;AASJ;;AANA,mCAAA;AACA,kCAAA;AACA;EACE,wCAAA,EAAA,4BAAA;EACA,sCAAA,EAAA,qBAAA;AASF;;AAJA,0BAAA;AACA;EACE,wCAAA,EAAA,yCAAA;EACA,sCAAA;AAOF;;AAJA,qCAAA;AACA;EACE,yCAAA,EAAA,oCAAA;EACA,sCAAA;AAOF;;AALA,gDAAA;AACA;EACE;IACE,wCAAA;EAQF;EANA;IACE,wCAAA;EAQF;AACF;AALA;EACE,oCAAA;AAOF;;AAHA,4BAAA;AAEA,wEAAA;AACA;EACE,WAAA,EAAA,OAAA;EACA,qBAAA;EACA,kBAAA;AAKF;;AAFA,6CAAA;AACA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;AAKF;;AAFA,wBAAA;AACA;;EAEE,sBAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;AAKF;;AAFA,kCAAA;AACA;EACE,yBAAA;AAKF;;AAFA;;EAEE,yBAAA;AAKF;;AAFA,8BAAA;AACA;EACI,sCAAA;AAKJ;;AAHA;EACE,oCAAA;AAMF;;AAHA;EACE;IACE,uBAAA;EAMF;EAJA;IACE,yBAAA;EAMF;AACF;AADE;;EAEE,sBAAA;AAGJ;;AAAA,sCAAA;AACA,wBAAA;AAEA,WAAA;AAEE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EAEA,2BAAA;AAAJ;AACI;EAPF;IAQI,sBAAA;IACA,kBAAA;EAEJ;EAAI;IACE,qBAAA;EAEN;AACF;AAEE;EACE,8CAAA;AAAJ;AAGE;EACE,OAAA;EACA,kBAAA;AADJ;AAIE;EACE,WAAA;AAFJ;;AAMA,oCAAA;AAEA,iCAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;AAJF;AAME;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAJJ;AAOE;EACE,WAAA;AALJ;AAQE;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,SAAA;EACA,iBAAA;AANN;AASE;EACE,OAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBC9yBe;ADuyBnB;AAUE;EACE,cAAA;AARJ;;AAaA,+BAAA;AAIA;EACE,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gCAAA;AAbF;;AAgBA;EACE;IACE,6BAAA;EAbF;EAeA;IACE,4BAAA;EAbF;AACF;AAeA;EACI,eAAA;AAbJ","sourcesContent":["@import 'styles/core/variables.scss';\n\n.spinner-border-sm {\n    height: $font-size-sm;\n    width: $font-size-sm;\n}\n\n.action-icon--disabled {\n    opacity: 0.35;\n    color: #9ca3af;\n    cursor: default;\n    pointer-events: none;\n}\n\n// Enabled icons are visually distinct from disabled ones.\n.action-icon--enabled {\n    color: #2196f3;\n}\n\n.row-reorder__header {\n    width: 60px;\n    min-width: 60px;\n    max-width: 60px;\n}\n\n.row-reorder__header-icon {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    color: #9aa3ad;\n    line-height: 1;\n    font-size: 30px;\n}\n\n.row-reorder__header-icon svg {\n    fill: currentColor;\n}\n\n.row-reorder__cell {\n    width: 60px;\n    min-width: 60px;\n    max-width: 60px;\n    text-align: center;\n}\n\n.row-reorder__handle {\n    border: 0;\n    background: transparent;\n    color: #9aa3ad;\n    cursor: grab;\n    padding: 0;\n    line-height: 1;\n}\n\n.row-reorder__handle:active {\n    cursor: grabbing;\n}\n\n.row-reorder__icon {\n    font-size: 14px;\n}\n\n::ng-deep .cdk-drag-preview {\n    box-sizing: border-box;\n    background: #ffffff;\n    border: 1px solid #d9dee5;\n}\n\n/* Keep dragged row preview identical to table row layout (no compressed cells). */\n::ng-deep .datatable-table tr.cdk-drag-preview {\n    display: table;\n    table-layout: fixed;\n    width: 100% !important;\n    background: #ffffff;\n}\n\n::ng-deep .datatable-table tr.cdk-drag-preview > td {\n    box-sizing: border-box;\n}\n\n::ng-deep .cdk-drag-placeholder {\n    opacity: 0;\n}\n\n::ng-deep .cdk-drop-list-dragging tr:not(.cdk-drag-placeholder) {\n    transition: transform 180ms ease;\n}\n\n\n::ng-deep ngb-pagination ul {\n    margin-bottom: 0 !important;\n}\n\n/* Table */\n.datatable-table {\n  --bs-table-color: var(--bs-body-color);\n  --bs-table-bg: transparent;\n  --bs-table-border-color: #e0e5ec;\n  --bs-table-accent-bg: transparent;\n  --bs-table-striped-color: var(--bs-body-color);\n  --bs-table-striped-bg: rgba(0, 0, 0, 0.05);\n  --bs-table-active-color: var(--bs-body-color);\n  --bs-table-active-bg: rgba(0, 0, 0, 0.1);\n  --bs-table-hover-color: var(--bs-body-color);\n  --bs-table-hover-bg: rgba(224, 229, 236, 0.25);\n  width: 100%;\n  margin-bottom: 1rem;\n  color: var(--bs-table-color);\n  vertical-align: top;\n  border-color: var(--bs-table-border-color);\n}\n.datatable-table > :not(caption) > * > * {\n  padding: 0.75rem 0.75rem;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n.datatable-table > tbody {\n  vertical-align: inherit;\n}\n.datatable-table > thead {\n  vertical-align: bottom;\n}\n.datatable-table > :not(caption) > * {\n  border-width: 1px 0;\n}\n.datatable-table > :not(caption) > * > * {\n  border-width: 0 1px;\n}\n.datatable-table > tbody > tr:hover > * {\n  --bs-table-accent-bg: var(--bs-table-hover-bg);\n  color: var(--bs-table-hover-color);\n}\n\n// Disable hover styling when requested.\n.datatable-table > tbody > tr.no-row-hover:hover > * {\n  --bs-table-accent-bg: transparent;\n  color: inherit;\n}\n.invoice .datatable-table tbody tr td {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n.datatable-table {\n  border-collapse: collapse;\n}\n\n.datatable-table > tbody > tr > td,\n.datatable-table > tbody > tr > th,\n.datatable-table > tfoot > tr > td,\n.datatable-table > tfoot > tr > th,\n.datatable-table > thead > tr > td,\n.datatable-table > thead > tr > th {\n  vertical-align: middle;\n  padding: $datatable-cell-padding;;\n}\n\n.datatable-table > thead > tr > th {\n  vertical-align: bottom;\n  text-align: left;\n  border-bottom: none;\n}\n\n.datatable-table > tfoot > tr > th {\n  vertical-align: bottom;\n  text-align: left;\n}\n\n.datatable-table th {\n  vertical-align: bottom;\n  text-align: left;\n}\n\n.table-cell-truncate {\n  display: inline-block;\n  max-width: 220px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.table-cell-truncate--with-badge {\n  overflow: visible;\n  max-width: none;\n}\n\n.table-cell__with-badge {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.table-cell__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.ocr-proc-operation__header,\n.ocr-proc-operation__cell {\n  text-align: center !important;\n}\n\n.ocr-proc-operation__trigger {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n/* Numeric amount cells use accounting-style alignment. */\n.datatable-table td.amount {\n  text-align: right;\n  font-variant-numeric: tabular-nums;\n}\n\n.datatable-table td.amount.amount-negative {\n  color: #dc2626;\n}\n\n.datatable-table td.erp-rule-cell {\n  text-align: center !important;\n}\n\n.datatable-table td.erp-rule-cell .erp-rule-cell__content {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto;\n  margin: 0 auto;\n}\n\n:host ::ng-deep .datatable-table td.erp-rule-cell .e-checkbox-wrapper,\n:host ::ng-deep .datatable-table td.erp-rule-cell .e-checkbox {\n  float: none !important;\n  margin: 0 auto !important;\n  display: inline-flex !important;\n}\n\n.table-note {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #4a4f57;\n  font-size: 0.95rem;\n  margin-bottom: 10px;\n}\n\n.table-note__count {\n  color: #d92b2b;\n  font-weight: 600;\n}\n\n.table-new-badge {\n  margin-left: 8px;\n  background-color: #fde2e2;\n  color: #a94442;\n  font-weight: 600;\n  font-size: 1em;\n  padding: 0.25em 0.6em;\n}\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.6);\n  }\n  70% {\n    transform: scale(1.05);\n    box-shadow: 0 0 0 2px rgba(220, 53, 69, 0);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.pulse-badge {\n  animation: pulse 1.8s infinite;\n}\n\n.table-mapping-badge {\n  margin-left: 8px;\n  background-color: #fde2e2;\n  color: #a94442;\n  font-weight: 600;\n  font-size: 0.95em;\n  padding: 0.25em 0.6em;\n}\n\n.datatable-table th a {\n  text-decoration: none;\n  color: inherit;\n}\n\n.table-link-icon {\n  color: #c2c6cc;\n  font-weight: 600;\n  display: inline-block;\n}\n\n.table-link-icon--active {\n  color: #2196F3;\n  font-weight: 600;\n}\n\n.table-link-icon--prefilled {\n  color: #2196F3;\n  font-weight: 600;\n}\n\n.table-link-header {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n/* Mapping status pill (used in column-mapping modal table) */\n.mapping-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 0.8rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.mapping-status-badge--mapped {\n  background-color: #dcfce7;\n  color: #15803d;\n}\n\n.mapping-status-badge--na {\n  background-color: #e5e7eb;\n  color: #6b7280;\n}\n\n/* Upload-session status pill styles */\n.session-status-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 10px;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.session-status-badge--open {\n  background-color: #e5e7eb;\n  color: #6b7280;\n}\n\n.session-status-badge--processing {\n  background-color: #dbeafe;\n  color: #1d4ed8;\n}\n\n.session-status-badge--processed {\n  background-color: #e0f2fe;\n  color: #0369a1;\n}\n\n.session-status-badge--reconciled {\n  background-color: #dcfce7;\n  color: #15803d;\n}\n\n.session-status-badge--default {\n  background-color: #f3f4f6;\n  color: #4b5563;\n}\n\n::ng-deep .e-dropdown-popup .mapping-option-disabled,\n::ng-deep .e-dropdown-popup .e-list-item .mapping-option-disabled,\n::ng-deep .e-dropdownbase .mapping-option-disabled,\n::ng-deep .e-dropdownbase .e-list-item .mapping-option-disabled {\n  color: #9aa3ad !important;\n}\n\n/*Table Sorter icon - Part of Table*/\n\n.datatable-sorter {\n  display: inline-block;\n  height: 100%;\n  position: relative;\n  width: 100%;\n  padding-right: 1rem;\n}\n\n.datatable-sorter::before,\n.datatable-sorter::after {\n  content: \"\";\n  height: 0;\n  width: 0;\n  position: absolute;\n  right: 4px;\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  opacity: 0.2;\n}\n\n.datatable-sorter::before {\n  bottom: 4px;\n}\n\n.datatable-sorter::after {\n  top: 0px;\n}\n\n.asc .datatable-sorter::after,\n.desc .datatable-sorter::before {\n  opacity: 0.6;\n}\n\n.datatables-empty {\n  text-align: center;\n}\n\n.datatable-top::after,\n.datatable-bottom::after {\n  clear: both;\n  content: \" \";\n  display: table;\n}\n\n.btn-datatable {\n  height: 20px !important;\n  width: 20px !important;\n  font-size: 0.75rem;\n  border-radius: 0.35rem !important;\n}\n\n.sbp-dropdown-example .dropdown-menu {\n  display: inline-block;\n  position: relative;\n  float: none;\n  max-width: 15rem;\n}\n\n.sbp-preview {\n  border-radius: 0.35rem;\n  border: 0.25rem solid #e0e5ec;\n  border-style: solid;\n}\n.sbp-preview .sbp-preview-content {\n  padding: 1.5rem;\n  border-bottom: 1px solid #e0e5ec;\n  position: relative;\n}\n.sbp-preview .sbp-preview-code {\n  background-color: #f2f6fc;\n  padding: 1.5rem;\n  border-bottom: 1px solid #e0e5ec;\n}\n.sbp-preview .sbp-preview-code .nav-tabs {\n  border-bottom-color: transparent;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n.sbp-preview .sbp-preview-code .nav-tabs .nav-item .nav-link {\n  border-bottom: 0;\n  display: inline-flex;\n  align-items: center;\n}\n.sbp-preview .sbp-preview-code .nav-tabs .nav-item .nav-link.active {\n  border-color: transparent;\n  background-color: #2f2f2f;\n  color: white;\n}\n.sbp-preview .sbp-preview-code .nav-tabs .nav-item .nav-link .img-pug {\n  height: 1em;\n  padding: 1px 0;\n}\n.sbp-preview .sbp-preview-text {\n  background-color: #f2f6fc;\n  font-size: 0.875rem;\n  padding: 1.5rem;\n}\n\ncode[class*=language-],\npre[class*=language-] {\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  color: #eee;\n  background: #2f2f2f;\n  font-family: \"SFMono-Regular\", \"Consolas\", \"Liberation Mono\", \"Menlo\", monospace;\n  font-size: 0.875rem;\n  line-height: 1.5em;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  hyphens: none;\n}\n\ncode[class*=language-]::-moz-selection,\npre[class*=language-]::-moz-selection,\ncode[class*=language-] ::-moz-selection,\npre[class*=language-] ::-moz-selection {\n  background: #363636;\n}\n\ncode[class*=language-]::-moz-selection, pre[class*=language-]::-moz-selection, code[class*=language-] ::-moz-selection, pre[class*=language-] ::-moz-selection {\n  background: #363636;\n}\n\ncode[class*=language-]::selection,\npre[class*=language-]::selection,\ncode[class*=language-] ::selection,\npre[class*=language-] ::selection {\n  background: #363636;\n}\n\n:not(pre) > code[class*=language-] {\n  white-space: normal;\n  border-radius: 0.2em;\n  padding: 0.1em;\n}\n\npre[class*=language-] {\n  overflow: auto;\n  position: relative;\n  margin: 0;\n  padding: 1rem;\n  max-height: 35rem;\n}\n\n.language-css > code,\n.language-sass > code,\n.language-scss > code {\n  color: #fd9170;\n}\n\n[class*=language-] .namespace {\n  opacity: 0.7;\n}\n\n.token.atrule {\n  color: #c792ea;\n}\n\n.token.attr-name {\n  color: #ffcb6b;\n}\n\n.token.attr-value {\n  color: #a5e844;\n}\n\n.token.attribute {\n  color: #a5e844;\n}\n\n.token.boolean {\n  color: #c792ea;\n}\n\n.token.builtin {\n  color: #ffcb6b;\n}\n\n.token.cdata {\n  color: #80cbc4;\n}\n\n.token.char {\n  color: #80cbc4;\n}\n\n.token.class {\n  color: #ffcb6b;\n}\n\n.token.class-name {\n  color: #f2ff00;\n}\n\n.token.comment {\n  color: #616161;\n}\n\n.token.constant {\n  color: #c792ea;\n}\n\n.token.deleted {\n  color: #ff6666;\n}\n\n.token.doctype {\n  color: #616161;\n}\n\n.token.entity {\n  color: #ff6666;\n}\n\n.token.function {\n  color: #c792ea;\n}\n\n.token.hexcode {\n  color: #f2ff00;\n}\n\n.token.id {\n  color: #c792ea;\n  font-weight: bold;\n}\n\n.token.important {\n  color: #c792ea;\n  font-weight: bold;\n}\n\n.token.inserted {\n  color: #80cbc4;\n}\n\n.token.keyword {\n  color: #c792ea;\n}\n\n.token.number {\n  color: #fd9170;\n}\n\n.token.operator {\n  color: #89ddff;\n}\n\n.token.prolog {\n  color: #616161;\n}\n\n.token.property {\n  color: #80cbc4;\n}\n\n.token.pseudo-class {\n  color: #a5e844;\n}\n\n.token.pseudo-element {\n  color: #a5e844;\n}\n\n.token.punctuation {\n  color: #89ddff;\n}\n\n.token.regex {\n  color: #f2ff00;\n}\n\n.token.selector {\n  color: #ff6666;\n}\n\n.token.string {\n  color: #a5e844;\n}\n\n.token.symbol {\n  color: #c792ea;\n}\n\n.token.tag {\n  color: #ff6666;\n}\n\n.token.unit {\n  color: #fd9170;\n}\n\n.token.url {\n  color: #ff6666;\n}\n\n.token.variable {\n  color: #ff6666;\n}\n\n.trash-icon {\n    cursor: pointer;\n    transition: transform 0.2s;\n}\n\n/*Table Highlights - Hover clicked*/\n/* Hover styling for table cells */\n.hoverable:hover {\n  background-color: rgba(0, 123, 255, 0.1); /* Light blue hover effect */\n  transition: background-color 0.3s ease; /* Smooth animation */\n}\n\n\n\n/* Highlight clicked row */\n.datatable-table tbody tr.clicked td {\n  background-color: rgba(0, 123, 255, 0.2); /* Slightly darker blue for clicked row */\n  transition: background-color 0.3s ease;\n}\n\n/* Optional: Highlight hovered rows */\n.datatable-table tbody tr:hover td {\n  background-color: rgba(0, 123, 255, 0.15); /* Hover effect for the entire row */\n  transition: background-color 0.3s ease;\n}\n/* Add animation for smoother click transition */\n@keyframes click-highlight {\n  from {\n    background-color: rgba(0, 123, 255, 0.3);\n  }\n  to {\n    background-color: rgba(0, 123, 255, 0.2);\n  }\n}\n\n.datatable-table tbody tr.clicked td {\n  animation: click-highlight 0.4s ease;\n}\n\n\n/* Table Layout, Auto - Fit*/\n\n/* 2. Inner container is auto-width, letting the table size by content */\n.datatable-container {\n  width: 100%; /*auto*/\n  display: inline-block; // ensures the container only wraps what's needed\n  position: relative;\n}\n\n/* 3. Table: let it expand based on content */\n.datatable-table {\n  border-collapse: collapse;\n  table-layout: auto;\n  width: 100%;      // table will grow based on content \"auto\"\n}\n\n/* 4. Th and Td styles */\n.datatable-table th,\n.datatable-table td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  vertical-align: middle;\n  white-space: nowrap;      // keep text on one line\n}\n\n/* 5. Hover and highlight styles */\n.hoverable:hover {\n  background-color: #f9f9f9;\n}\n\n.datatable-table tr.clicked td,\n.datatable-table th.clicked {\n  background-color: #f0f0f0;\n}\n\n/* Processing or repeat Icon */\n.processing-icon {\n    transition: transform 0.5s ease-in-out;\n}\n.processing-icon:hover {\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.cwr-datatable {\n  // Target existing classes inside this BEM block\n  .datable-container,\n  .datatable-table {\n    width: 100% !important;\n  }\n}\n/*Start: Table Controls in datatables*/\n/* table-controls.scss */\n\n/* Layout */\n.table-controls {\n  &__footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem;\n\n    /* Responsive adjustments */\n    @media (max-width: 768px) {\n      flex-direction: column;\n      text-align: center;\n\n      & > * {\n        margin-bottom: 0.5rem;\n      }\n    }\n  }\n\n  &__pagination {\n    /* Additional pagination styles if necessary */\n  }\n\n  &__info {\n    flex: 1;\n    text-align: center;\n  }\n\n  &__page-size {\n    width: auto;\n  }\n}\n\n/*END: Table Controls in datatables*/\n\n/*Start: Table Search with Title*/\n.table-search {\n  display: flex;\n  align-items: center;\n  width: 100%;\n\n  &__input-wrapper {\n    flex: 0 0 auto; // Maintains the input's natural width\n    margin-right: 2rem; // Space between input and title\n    max-width: 20rem;\n  }\n\n  &__input {\n    width: 100%; // Ensures input takes full width of its wrapper\n  }\n\n  &__spinner-loading {\n      width: 52px;\n      position: absolute;\n      top: 1px;\n      right: 0;\n      border: 0;\n      margin-right: 1px;\n  }\n\n  &__title-wrapper {\n    flex: 1; // Occupies remaining space\n    display: flex;\n    justify-content: left;\n    align-items: center;\n    text-align: left;\n    font-weight: bold;\n    color: #1da1f5;\n    font-size: $card-header-size;\n  }\n\n  &__session-id {\n    color: #2563eb;\n  }\n}\n\n\n/*End: table Search with Title*/\n\n\n\n.skeleton {\n  height: 1rem;\n  background: #e0e0e0;\n  border-radius: 4px;\n  animation: shimmer 1.5s infinite;\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: 200px 0;\n  }\n}\n.style__file-list-view td {\n    font-size: 11px;\n}\n","// === Override _typography variables - For Themeable Styling\n@use \"sass:math\";\n\n// Core definitions (can be left as defaults)\n$font-size-base: 1rem; // default (typically 16px)\n$font-size-lg:   $font-size-base * 1.25;\n$font-size-sm:   $font-size-base * 0.88;\n\n// Theme variable: Change this to $font-size-base, $font-size-lg, or $font-size-sm\n$theme-font-size: $font-size-sm; // Theme Control\n\n\n$h1-font-size: $theme-font-size * 1.5;\n$h2-font-size: $theme-font-size * 1.4;\n$h3-font-size: $theme-font-size * 1.3;\n$h4-font-size: $theme-font-size * 1.2;\n$h5-font-size: $theme-font-size * 1.1;\n$h6-font-size: $theme-font-size;\n\n$small-font-size:             0.875em;\n\n$lead-font-size:              $theme-font-size * 1.1;\n\n\n// =============================\n// Themable Padding\n// =============================\n\n// Base datatable padding multiplier (if theme font size is 1rem, this yields 0.75rem)\n$datatable-padding-multiplier: 0.75 !default;\n\n// Padding reduction factor (15% reduction means multiplying by 0.85)\n$padding-reduction-factor: 0.85 !default;\n\n// Compute the final datatable cell padding\n$datatable-cell-padding: $theme-font-size * $datatable-padding-multiplier * $padding-reduction-factor;\n\n// These multipliers are based on the default design (using $font-size-sm)\n\n// Convert $font-size-sm (with rem unit) to a unitless number by dividing by 1rem.\n$card-header-multiplier: math.div(1.1, math.div($font-size-sm, 1rem));\n$main-menu-multiplier:  math.div(1, math.div($font-size-sm, 1rem));\n$client-name-multiplier: math.div(1.2, math.div($font-size-sm, 1rem));\n$button-text-multiplier: math.div(1, math.div($font-size-sm, 1rem));\n\n// Compute the actual sizes relative to the current theme\n$card-header-size: $theme-font-size * $card-header-multiplier;\n$main-menu-size:   $theme-font-size * $main-menu-multiplier;\n$client-name-size: $theme-font-size * $client-name-multiplier;\n$button-text-size: $theme-font-size * $button-text-multiplier;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
